import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@material-ui/core";
import React from "react";
import { isFunction } from "../../Utils";

function AlertDialog({
    formOpen,
    content,
    confirmButton,
    closeButton,
    onClosed,
    contentStyle,
    PaperProps,
    title,
}) {
    return (
        <Dialog
            onClose={
                isFunction(closeButton?.action) ? closeButton.action : () => {}
            }
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            open={formOpen}
            onClosed={onClosed}
            fullWidth={true}
            PaperProps={PaperProps}
        >
            {title && <DialogTitle>{title}</DialogTitle>}
            <DialogContent id="alert-dialog-title">
                <DialogContentText
                    id="alert-dialog-description"
                    style={contentStyle}
                >
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {closeButton && (
                    <Button onClick={closeButton.action}>
                        {closeButton.label}
                    </Button>
                )}
                {confirmButton && (
                    <Button onClick={confirmButton.action}>
                        {confirmButton.label}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
export default AlertDialog;
